import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initCcLibrarySetModuleState: types.CcLibrarySetModuleState = {
    data: null,
    showConfirmDelete: false,
}

const ccLibrarySetModuleReducer = produce((
    draft: types.CcLibrarySetModuleState = initCcLibrarySetModuleState,
    action: ActionTypes = null,
): types.CcLibrarySetModuleState => {
    switch (action.type) {
        case types.CC_LIBRARY_SET_MODULE_DATA:
            draft.data = action.data
            return draft

        case types.CC_LIBRARY_SET_MODULE_SHOW_CONFIRM:
            draft.showConfirmDelete = action.show
            return draft

        default:
            return draft
    }
})
export default ccLibrarySetModuleReducer
